import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";
import { FeeScheduleTemplateCategoryAssignmentPayload } from "./create-fee-schedule-template-api-request";

/**
 * What a template's categories say, as one comparable string per category.
 *
 * Both the order of the categories and the person named for each are part of what a save has to
 * notice. Comparing ids alone would miss the edit this exists for — naming somebody for a category
 * the template already had — and that edit would never be sent.
 */
function categorySignature(assignment: FeeScheduleTemplateCategoryAssignmentPayload): string {
  const { userId, legalEntityId } = assignment.teamMember ?? {};
  return `${assignment.categoryId}:${userId ?? ""}:${legalEntityId ?? ""}`;
}

function categoryAssignments(template: FeeScheduleTemplate): FeeScheduleTemplateCategoryAssignmentPayload[] {
  return template.categories.map((category) => ({
    categoryId: category.id.toString(),
    // See the note on the same expression in FeeScheduleTemplateCommand.
    teamMember: category.teamMemberIsMasked ? null : category.teamMember?.toJSON() ?? null,
  }));
}

export default class UpdateFeeScheduleTemplateCommand {
  public payload: JsonPatchOperation[] = [];

  constructor(originalTemplate: FeeScheduleTemplate, updatedTemplate: FeeScheduleTemplate) {
    if (updatedTemplate.name !== originalTemplate?.name)
      this.payload.push({
        op: "replace",
        path: "/name",
        value: updatedTemplate.name,
      });
    if (updatedTemplate.tags !== originalTemplate?.tags)
      this.payload.push({
        op: "replace",
        path: "/tags",
        value: updatedTemplate.tags.map((tag) => tag.value),
      });
    const originalAssignments = categoryAssignments(originalTemplate);
    const updatedAssignments = categoryAssignments(updatedTemplate);
    const originalSignatures = originalAssignments.map(categorySignature);
    const updatedSignatures = updatedAssignments.map(categorySignature);
    if (
      originalSignatures.length !== updatedSignatures.length ||
      originalSignatures.some((signature, index) => signature !== updatedSignatures[index])
    ) {
      this.payload.push({
        op: "replace",
        path: "/categoryAssignments",
        value: updatedAssignments,
      });
    }
  }
}
